export class CateringCredit {
  amount: number;
  cateringCreditId: number;
  clientId: number;
  flightRequestId: number;
  legId: number;
  legRequestId: number;
}
